import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilePdf } from "@fortawesome/free-solid-svg-icons"
import Button from "../../button"

const DocumentCell = ({
  value,
  documentHandler,
  row: {
    original: { id }
  }
}) => {
  const handleClick = (event) => {
    event.preventDefault()
    if (documentHandler !== undefined) documentHandler(id, value)
  }

  return value ? (
    <Button onClick={handleClick} size="small" variant="secondary" outlined>
      <FontAwesomeIcon icon={faFilePdf} />
    </Button>
  ) : null
}

DocumentCell.propTypes = {
  value: PropTypes.string,
  documentHandler: PropTypes.func
}

DocumentCell.defaultProps = {
  value: "",
  documentHandler: undefined
}

export default DocumentCell
